import { createStore } from "vuex";
import { login,submitAppInfo,submitAppInfo2,bury2,buryConfig } from '@api/index.js'
import { setToken, setTokenFromStorage, removeToken, removeTokenFromStorage, setPhone,setPhoneFromStorage} from '../utils/tool'
import  dayjs  from "dayjs";
 const store = createStore({
    state () {
        return {
            token : '',
            toast_state: false,
            toast_txt: '',
            phone: "",
            isApp:false,
            bury:{},
            buryCache:[],
            buryConfig:{}
        }
    },
    getters: {
        token (state) {
            return state.token
        },
        toast_txt (state) {
            return state.toast_txt
        }
    },
    mutations: {
        setBuryConfig(state, dict) {
            state.buryConfig = dict
        },
        setBury(state, newBury) {
            state.bury = newBury
            window.localStorage.setItem("bury", JSON.stringify(state.bury))
            console.log(JSON.stringify(state.bury))
        },
        setburyDelay(state, newBury) {
            state.buryCache.push(newBury)
            console.log(JSON.stringify(state.buryCache))
            window.localStorage.setItem("bury", JSON.stringify(state.buryCache))
        },
        setToken(state, token) {
            state.token = token
        },
        setToast(state, show) {
            state.toast_state = show
        },
        setToastTxt(state, txt) {
            state.toast_txt = txt
        },
        setApp(state, isApp) {
            state.isApp = isApp
        },
        clearToken(state) {
            state.token = ''
            removeToken()
            removeTokenFromStorage()
        },
        setPhone(state, phone) {
            state.phone = phone
            setPhone(phone)
        },
        clearBury(state) {
            state.bury = {}
        },  
        clearBuryCache (state) {
            state.buryCache = []
        }     
    },
    actions: {
        async fetchConfig({ commit }) {
            const config = await buryConfig();                    
            commit('setBuryConfig', config.data)
        },
        bury({ commit }, newBury) {
            newBury['triggerTime'] = dayjs().valueOf()
            bury2([newBury])            
            commit('clearBury')
        },
        buryCache({ commit }, newBury) {
            newBury['triggerTime'] = dayjs().valueOf()
            commit('setburyDelay', newBury)
        },
        uploadBury({ commit,state }) {
            console.log(state.buryCache)
            bury2(state.buryCache)
            commit('clearBuryCache')             
        },
        clearBuryCache({ commit }) {                  
          commit('clearBuryCache')           
        },
        closeToast({ commit }) {
            commit('setToast', false)
        },
        showToast({ commit }) {
            commit('setToast', true)
        },
        setToastTxt({ commit }, txt) {
            commit('setToastTxt', txt)
        },
        clearToken({ commit }) {
            commit('clearToken')
        },        
        setToken( { commit }, token ) {
            commit('setToken', token)                    
            setToken(token)
            setTokenFromStorage(token)
        },
        customLogin2({ commit }, appInfo) {
            return new Promise((resolve, reject) => {
                console.log(345);
                submitAppInfo2(appInfo.params, appInfo.customHeader).then(response => {
                  if(response.code == 0 ){
                      const { token } = response.data
                      commit('setToken', token)
                      commit('setApp', true)
                      setToken(token)
                      setTokenFromStorage(token)
                      resolve()
                      
                  } else {
                      reject(response.msg)    
                  }   
                }).catch(error => {
                  reject(error)
                })
              })
        },
        customLogin({ commit }, appInfo) {
            return new Promise((resolve, reject) => {
                console.log(345);
                submitAppInfo(appInfo.params, appInfo.customHeader).then(response => {
                  if(response.code == 0 ){
                      const { token,isRegister } = response.data
                      commit('setToken', token)
                      commit('setApp', true)
                      setToken(token)
                      setTokenFromStorage(token)
                      resolve({
                        isRegister
                      })
                  } else {
                      reject(response.msg)    
                  }   
                }).catch(error => {
                  reject(error)
                })
              })
        },
        login({ commit }, userInfo) {            
            const { phone, code } = userInfo
            return new Promise((resolve, reject) => {
              login({ phone: '91'+phone.trim(), code: code }).then(response => {
                if(response.code == 0 ){
                    const { token,isRegister } = response.data
                    commit('setToken', token)
                    commit('setPhone', phone)
                    commit('setApp', false)
                    setToken(token)
                    setPhone(phone)
                    setTokenFromStorage(token)
                    setPhoneFromStorage(phone)
                    resolve({
                        isRegister
                    })
                } else {
                    reject(response.msg)    
                }   
              }).catch(error => {
                reject(error)
              })
            })
          },
    }
})
export default store